import { initializeApp } from "firebase/app";

const firebaseConfig = process.env.REACT_APP_ENV === "test" ? {
    apiKey: "AIzaSyBEQ0RqP0Z1S8sEacI3mgvBpozR-ECfwB8",
    authDomain: "oasisresidencewebdev.firebaseapp.com",
    projectId: "oasisresidencewebdev",
    storageBucket: "oasisresidencewebdev.appspot.com",
    messagingSenderId: "10881239351",
    appId: "1:10881239351:web:797b3054d2b085e8deb2b2"
} :
{
    apiKey: "AIzaSyBP_sMdu-HOTvKgJIm2XUpfXqlaYtNqLF4",
    authDomain: "oasisresidenceweb-b7f37.firebaseapp.com",
    projectId: "oasisresidenceweb-b7f37",
    storageBucket: "oasisresidenceweb-b7f37.appspot.com",
    messagingSenderId: "1042123150157",
    appId: "1:1042123150157:web:291f331b8a79ea4dea5d04",
    measurementId: "G-G3CTJPXKC1"
};

const app = initializeApp(firebaseConfig);

export default app;